import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css, cx } from '@bd/bdui-styles/emotion';
import sortOptions from '../../components/SortOptions/homes';
import AccordionToggle from '../../components/AccordionToggle';
// import Filters from '../../components/Filters';
import HomesResults from '../Homes/HomesResults';

const styles = css`
  .SectionHomes_head {
    display: none;
    @media (min-width: 768px) {
      display: block;
      margin-bottom: 0;
    }
  }
  .SectionHomes_head-noResults {
    @media (min-width: 768px) {
      margin-bottom: 0.625em;
    }
  }
  .SectionHomes_noResults {
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0.022353em;
    line-height: 1.941176;
    color: #fff;
    margin: 0;
    text-align: center;
    @media (min-width: 768px) {
      font-size: 18px;
    }
    @media (min-width: 992px) {
      font-size: 19px;
    }
  }
  .SectionHomes_headerWrapper {
    @media (min-width: 768px) {
      align-items: center;
      margin-bottom: 18px;
      text-align: center;
      > div:nth-child(2) > div { /* Filters component */
        margin-bottom: 0;
      }
    }
  }
`;


class SectionHomes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[0],
    };

    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    this.setState({
      sort,
    });
  }

  render() {
    const { className, homes } = this.props;
    const { sort } = this.state;
    const length = homes.length;
    return (
      <div className={cx(styles, className)}>
        <AccordionToggle
          openOnId="available-homes"
          button="Available Homes"
          id="available-homes"
        >
          <div className="SectionHomes_headerWrapper">
            <h3 className={[
              'CommunityDetail_sectionHead',
              'SectionHomes_head',
              'GoldText',
              !length ? 'SectionHomes_head-noResults' : '',
            ].join(' ').trim()}
            >
              Available Homes
            </h3>
          </div>
          {/* {
            length > 0 &&
            <div className="d-flex justify-content-center">
              <Filters
                type="homes"
                filterOptions={[
                  {
                    type: 'MultiSelect',
                    filter: 'Beds',
                    title: 'Beds',
                  },
                  {
                    type: 'MultiSelect',
                    filter: 'Baths',
                    title: 'Baths',
                  },
                  {
                    type: 'MultiSelect',
                    filter: 'Price',
                    title: 'Price',
                  },
                ]}
                activeSort={sort}
                sortOptions={sortOptions}
                onSortSelect={this.setSort}
              />
            </div>
          } */}
          {
            length > 0 &&
            <div className="container-fluid">
              <HomesResults homes={homes} sort={sort} />
            </div>
          }
          {
            !length &&
            <p className="SectionHomes_noResults">
              {'No floor plan information available for this property at this time.'}
            </p>
          }
        </AccordionToggle>
      </div>
    );
  }
}

SectionHomes.propTypes = {
  className: PropTypes.string,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

SectionHomes.defaultProps = {
  className: undefined,
};

export default withData({
  community: true,
  homes: true,
})(SectionHomes);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/SectionHomes.js